import Bunnings from '../containers/Bunnings';
import Enquire from '../containers/Enquire';
import Install from '../containers/Install';
import Error from '../components/Error';
import StoreList from '../components/StoreList';
import Success from '../containers/Success';
import createRouteMap from '../../utils/createRouteMap';

export default createRouteMap([
  {
    path: '/',
    component: Bunnings,
    routes: [
      {
        path: '/install',
        component: Install
      },
      {
        path: '/request_quote',
        component: Enquire,
        props: {
          buttonText: 'Arrange installation',
          basePath: 'request_quote'
        }
      },
      {
        path: '/success/:job',
        component: Success
      },
      {
        path: '/success',
        component: Success
      },
      {
        path: '/stores',
        component: StoreList
      },
      {
        path: '/error',
        component: Error
      }
    ]
  }
]);
